import React from "react";

export const Logo = ({ size = 28, showText = true, className = "", textColor = "text-gray-900", iconColor }) => {
  const stroke = iconColor || "#7C3AED";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="optimus-prime-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <path
          d="M12 12 C 5 12, 5 28, 12 28 C 18 28, 22 12, 28 12 C 35 12, 35 28, 28 28 C 22 28, 18 12, 12 12 Z"
          stroke={stroke}
          strokeWidth="3.5"
          fill="none"
          strokeLinecap="round"
        />
        <circle cx="20" cy="20" r="2.5" fill={stroke} />
      </svg>
      {showText && (
        <span className={`font-extrabold tracking-tight ${textColor}`} style={{ fontSize: size * 0.55, letterSpacing: '-0.02em' }}>
          OPTIMUS PRIME
        </span>
      )}
    </div>
  );
};

export default Logo;
